module.exports = __webpack_public_path__ + "img/opera.54a123ec.svg";